import { render } from "./QualityInspection.vue?vue&type=template&id=0b5e72cd"
import script from "./QualityInspection.vue?vue&type=script&lang=js"
export * from "./QualityInspection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__